import { Link } from "react-router-dom";
import { Layout } from "../components/layout.tsx";
import { useAuth } from "../context/auth.tsx";

export function HomePage() {
  const { user } = useAuth();

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Dashboard</h1>
          <p className="mt-1 text-gray-400">Welcome back, {user?.name ?? user?.email}</p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          <StatCard label="Role" value={user?.role ?? "—"} />
          <StatCard
            label="Last login"
            value={user?.lastLoginAt != null ? new Date(user.lastLoginAt).toLocaleString() : "—"}
          />
          <StatCard label="MFA" value={user?.mfaEnabled ? "Enabled" : "Disabled"} />
        </div>

        <div className="rounded-xl border border-gray-800 bg-gray-900 p-6">
          <h2 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-400">
            Platform Infrastructure
          </h2>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
            <NavCard to="/events" label="Event Log" description="Audit all system events" />
            <NavCard to="/workflows" label="Workflows" description="Active workflow runs" />
            <NavCard to="/jobs" label="AI Jobs" description="Agent job history" />
            <NavCard to="/approvals" label="Approvals" description="Pending human decisions" />
          </div>
        </div>

        <div className="rounded-xl border border-gray-800 bg-gray-900 p-6">
          <h2 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-400">
            Departments
          </h2>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
            <NavCard to="/crm" label="CRM" description="Leads, clients & proposals" />
            <NavCard to="/marketing" label="Marketing" description="Campaigns, SEO & outreach" />
            <NavCard to="/knowledge" label="Knowledge" description="Documents & search" />
            <NavCard to="/delivery" label="Delivery" description="Sprints, tasks & QA" />
            <NavCard to="/ops" label="Operations" description="Agents, scheduler & tools" />
            <NavCard to="/finance" label="Finance" description="Quotes, invoices & reports" />
            <NavCard to="/support" label="Support" description="Tickets, SLA & health" />
            <NavCard to="/admin" label="Admin" description="Orgs, keys & subscription" />
          </div>
        </div>
      </div>
    </Layout>
  );
}

function StatCard({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl border border-gray-800 bg-gray-900 p-5">
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
      <p className="mt-1 text-lg font-semibold text-white">{value}</p>
    </div>
  );
}

function NavCard({ to, label, description }: { to: string; label: string; description: string }) {
  return (
    <Link
      to={to}
      className="block rounded-lg border border-gray-700 bg-gray-800/60 p-4 transition-colors hover:bg-gray-800"
    >
      <p className="text-sm font-semibold text-white">{label}</p>
      <p className="mt-1 text-xs text-gray-500">{description}</p>
    </Link>
  );
}
